import { createEffect } from 'effector';
import * as request from '../../../api/products';

export const getProductList = createEffect((data) => request.getProductList(data));
